/**
 * Created by daniel on 23/04/17.
 */

export const SET_UI_HOVERED_CONTENT_ITEM = "UI_HOVERED_CONTENT_ITEM";
export const SET_UI_SELECTED_CONTENT_ITEM = "UI_SELECTED_CONTENT_ITEM";
export const SET_UI_DRAGGED_CONTENT_ITEM = "SET_UI_DRAGGED_CONTENT_ITEM";
export const SET_UI_DROPZONE_COORDS = "SET_UI_DROPZONE_COORDS";
export const SET_UI_TOOLBOX_VISIBILITY = "SET_UI_TOOLBOX_VISIBILITY";
export const SET_UI_TOOLBOX_PINNED = "SET_UI_TOOLBOX_PINNED";
export const SET_UI_TOOLBOX_ACTIVETAB = "SET_UI_TOOLBOX_ACTIVETAB";

export function setUiHoveredContentItem(contentId) {
  return {
    type: SET_UI_HOVERED_CONTENT_ITEM,
    contentId,
  }
}

export function setUiSelectedContentItem(contentId) {
  return {
    type: SET_UI_SELECTED_CONTENT_ITEM,
    contentId,
  }
}

/**
 * Set the current element being dragged
 * @param {ContentDefinition} contentItem
 * @return {{type: string, contentItem: *}}
 */
export function setUiDraggedContentItem(contentItem) {
  return {
    type: SET_UI_DRAGGED_CONTENT_ITEM,
    contentItem,
  }
}

export function setUiDropzoneCoords(coords) {
  return {
    type: SET_UI_DROPZONE_COORDS,
    coords,
  }
}

export function setUiToolboxVisibility(visible) {
  return {
    type: SET_UI_TOOLBOX_VISIBILITY,
    visible,
  }
}
export function setUiToolboxPinned(pinned) {
  return {
    type: SET_UI_TOOLBOX_PINNED,
    pinned,
  }
}

export function setUiToolboxActiveTab(tab) {
  return {
    type: SET_UI_TOOLBOX_ACTIVETAB,
    tab,
  }
}


// WEBPACK FOOTER //
// ./src/App/Editor/state/ui/actions.js